import { render, staticRenderFns } from "./BranchNavbar.vue?vue&type=template&id=81cf79cc&scoped=true"
import script from "./BranchNavbar.vue?vue&type=script&lang=js"
export * from "./BranchNavbar.vue?vue&type=script&lang=js"
import style0 from "./BranchNavbar.vue?vue&type=style&index=0&id=81cf79cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cf79cc",
  null
  
)

export default component.exports